import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalFooter,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import DataBox from "components/databox";

const ViewModal = ({ isOpen, onClose, location }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent minH={"300px"} minW={"800px"} p={4} borderRadius={"16px"}>
        <ModalBody display={"flex"} flexDirection={"column"} gap={5}>
          <Text
            color={"#000000"}
            fontFamily="PlusJakartaSansSemiBold"
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
          >
            View Drop-off Location
          </Text>
          <Divider />
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Drop-off Location Name
            </Text>
            <Box border="1px solid #D9D9D9" borderRadius="8px" p={4}>
              <DataBox
                label={"name"}
                data={location?.name}
                color={"black"}
                containerStyles={{
                  minHeight: "48px",
                }}
              />
            </Box>
          </Box>
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Drop-off Location Addresses
            </Text>
            <Box
              border="1px solid #D9D9D9"
              borderRadius="8px"
              p={4}
              display={"flex"}
              flexDirection={"column"}
              gap={4}
            >
              <DataBox
                label={"Address"}
                data={location?.address}
                color={"black"}
                containerStyles={{
                  minHeight: "48px",
                }}
              />
              <DataBox
                label={"Postcode"}
                data={location?.postcode}
                color={"black"}
                containerStyles={{
                  minHeight: "48px",
                }}
              />
            </Box>
          </Box>
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Drop-off Location Contact
            </Text>
            <Box
              border="1px solid #D9D9D9"
              borderRadius="8px"
              p={4}
              display={"flex"}
              flexDirection={"column"}
              gap={4}
            >
              <DataBox
                label={"Contact Name"}
                data={location?.contact_name}
                color={"black"}
                containerStyles={{
                  minHeight: "48px",
                }}
              />
              <Flex gap={6} justifyContent={"space-between"}>
                <DataBox
                  label={"Email"}
                  data={location?.contact_email}
                  color={"black"}
                  containerStyles={{
                    minHeight: "48px",
                  }}
                />
                <DataBox
                  label={"Phone Number"}
                  data={location?.contact_phone_number}
                  color={"black"}
                  containerStyles={{
                    minHeight: "48px",
                  }}
                />
              </Flex>
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg={"transparent"}
              border={"1px solid #000000"}
              color="#000000"
              size="12px"
              borderRadius="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={onClose}
            >
              CLOSE
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ViewModal;